module.exports = __webpack_public_path__ + "static/media/Red_Chat_Bubble.47124521.png";